import { render } from "./SelectProductionToLose.vue?vue&type=template&id=64c7bc7b&ts=true"
import script from "./SelectProductionToLose.vue?vue&type=script&lang=ts"
export * from "./SelectProductionToLose.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__